import React from 'react';
import { formatText } from 'core/i18n';
import iconPadlock from 'assets/icons/icon-padlock.svg';
import './SafeDataAdvise.scss';

export const SafeDataAdvise = () => (
    <div className="advise-container">
        <img src={iconPadlock} alt="icon-padlock" />
        <p>{formatText('identity-videoSelfieOtherSecurityInfo')}</p>
    </div>
);
